var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSipBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 81,
    viewBox: "0 0 105 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 41,
    r: 77,
    fill: "#29C85D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.3446,
    cy: 40.9987,
    rx: 61.954,
    ry: 61.069,
    fill: "#23AC50"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0018,
    cy: 41.0018,
    r: 46.908,
    fill: "#1D9042"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSipBg);
export default __webpack_public_path__ + "static/media/sip-bg.0278357b52e3b2f9387b2dd648d19b98.svg";
export { ForwardRef as ReactComponent };